// ============================================
// Prenta — Constants
// ============================================

export const CATEGORIES = [
  { id: '3d_print', label: '3D Prentun', icon: '🖨️' },
  { id: 'laser', label: 'Laser skurður', icon: '⚡' },
  { id: 'cnc', label: 'CNC fræsun', icon: '⚙️' },
  { id: 'handcraft', label: 'Handverk', icon: '✂️' },
  { id: 'sewing', label: 'Saumur', icon: '🧵' },
  { id: 'paint', label: 'Málun', icon: '🎨' },
  { id: 'woodwork', label: 'Trésmíði', icon: '🪵' },
  { id: 'metalwork', label: 'Málmsmíði', icon: '🔩' },
  { id: 'electronics', label: 'Rafeindatækni', icon: '💡' },
  { id: 'other', label: 'Annað', icon: '🔧' },
];

export const AREAS = [
  { id: 'hofudborgarsvaedid', label: 'Höfuðborgarsvæðið' },
  { id: 'akureyri', label: 'Akureyri' },
  { id: 'selfoss', label: 'Selfoss' },
  { id: 'isafjordur', label: 'Ísafjörður' },
  { id: 'vestmannaeyjar', label: 'Vestmannaeyjar' },
  { id: 'egilsstadir', label: 'Egilsstaðir' },
  { id: 'annad', label: 'Annað' },
];

export const REQUEST_STATUSES = {
  open: { label: 'Opin', color: '#3b82f6' },
  quoted: { label: 'Tilboð komið', color: '#f59e0b' },
  accepted: { label: 'Samþykkt', color: '#10b981' },
  in_production: { label: 'Í framleiðslu', color: '#8b5cf6' },
  shipped: { label: 'Sent', color: '#06b6d4' },
  delivered: { label: 'Afhent', color: '#10b981' },
  cancelled: { label: 'Hætt við', color: '#ef4444' },
};

export const QUOTE_STATUSES = {
  pending: { label: 'Bíður', color: '#f59e0b' },
  accepted: { label: 'Samþykkt', color: '#10b981' },
  rejected: { label: 'Hafnað', color: '#ef4444' },
  expired: { label: 'Útrunnið', color: '#6b7280' },
};

export const ORDER_STATUSES = {
  confirmed: { label: 'Staðfest', color: '#3b82f6' },
  in_production: { label: 'Í framleiðslu', color: '#8b5cf6' },
  ready: { label: 'Tilbúið', color: '#10b981' },
  shipped: { label: 'Sent', color: '#06b6d4' },
  delivered: { label: 'Afhent', color: '#10b981' },
  disputed: { label: 'Ágreiningur', color: '#ef4444' },
};

export const PRICE_UNITS = {
  per_item: 'á stk.',
  per_hour: 'á klst.',
  per_kg: 'á kg',
  per_m2: 'á m²',
};

export const DELIVERY_METHODS = [
  { id: 'pickup', label: 'Sækja sjálfur' },
  { id: 'delivery', label: 'Afhending' },
  { id: 'mail', label: 'Póstsending' },
];
